/* eslint no-extra-bind: 0 */
class StubResponses {
  constructor() {
    this.responses = {};
  }

  set(resource, method, response) {
    this.responses[resource + method] = response;
  }

  contains(resource, method) {
    return (this.responses[resource + method] !== undefined);
  }

  fetch(resource, method) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(this.responses[resource + method]);
      }, 1000);
    });
  }
}

export default new StubResponses();
